import { jsx as _jsx } from "react/jsx-runtime";
import { MCPIcon } from "../products-menu-component/icons/index.js";
import { AI_TRUST_CENTER_SITE_LINK, MCP_PAGE_LINK, MONDAY_SIDEKICK_HEADER_LINK, MONDAY_VIBE_HEADER_LINK, MONDAY_AGENTS_HEADER_LINK } from "constants/links";
const AI_TRUST_CENTER_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/ai-turst-center_cfppbe.svg";
export const IMPACT_WITH_AI_IMG = "https://dapulse-res.cloudinary.com/image/upload/ai_impact_image_dromdw.png";
const AITrustCenterIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: AI_TRUST_CENTER_ICON_URL,
        alt: "",
        width: "20",
        height: "20"
    });
const SIDEKICK_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/sidekick_white_icon_x0dwnv.svg";
const VIBE_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/vibe_white_icon_sge8pn.svg";
const AGENTS_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/agents_white_icon_smp2ag.svg";
const sidekickIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: SIDEKICK_ICON_URL,
        alt: "",
        width: "48",
        height: "48"
    });
const VibeIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: VIBE_ICON_URL,
        alt: "",
        width: "48",
        height: "48"
    });
const MondayAgentsIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: AGENTS_ICON_URL,
        alt: "",
        width: "48",
        height: "48"
    });
export const AI_PRODUCTS_LINKS = [
    {
        Icon: sidekickIcon,
        title: "header.tabs.ai.products.sidekick.title",
        description: "header.tabs.ai.products.sidekick.description",
        link: MONDAY_SIDEKICK_HEADER_LINK
    },
    {
        Icon: VibeIcon,
        title: "header.tabs.ai.products.mondayVibe.title",
        description: "header.tabs.ai.products.mondayVibe.description",
        link: MONDAY_VIBE_HEADER_LINK
    },
    {
        Icon: MondayAgentsIcon,
        title: "header.tabs.ai.products.mondayAgents.title",
        description: "header.tabs.ai.products.mondayAgents.description",
        link: MONDAY_AGENTS_HEADER_LINK,
        isEarlyAccess: true
    }
];
export const AI_RESOURCES_LINKS = [
    {
        Icon: AITrustCenterIcon,
        text: "header.tabs.ai.resources.trustCenter",
        link: AI_TRUST_CENTER_SITE_LINK
    },
    {
        Icon: MCPIcon,
        text: "header.tabs.ai.resources.mcp",
        link: MCP_PAGE_LINK
    }
];
